import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppResolverErrorHandlerService } from '../../../shared/services/resolver-error-handler.service';
import { AppSftpService } from '../sftp.service';
import { BaseResolver } from '../../../shared/base-classes/base.resolver';
import { ISftpAccountListResolverData } from './sftp-account-list-models/sftp-account-list-resolver-data.interface';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppSftpAccountsListResolver extends BaseResolver<ISftpAccountListResolverData> {
  constructor(
    resolverErrorHandler: AppResolverErrorHandlerService,
    public sftpService: AppSftpService
  ) {
    super(resolverErrorHandler);
  }

  async handleResolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<ISftpAccountListResolverData> {
    return this.sftpService.getSftpAccountsListPageResolverData();
  }
}
